import { useGroupCompositeThumbnailStore } from '../store/useGroupCompositeThumbnailStore';

/** Subscribe to a cached composited thumbnail for a split-layer group. */
export const useGroupCompositeThumbnail = (groupId: string | undefined): string | undefined => {
  return useGroupCompositeThumbnailStore((state) => (groupId ? state.thumbnails[groupId] : undefined));
};

/** True only while a composite for this group is in flight and has not resolved. */
export const useGroupCompositeThumbnailPending = (groupId: string | undefined): boolean => {
  return useGroupCompositeThumbnailStore((state) => (groupId ? !!state.pendingGroupIds[groupId] : false));
};

type UseResolvedGroupThumbnailOptions = {
  fallbackUrl: string | null | undefined;
  groupId: string | undefined;
};

/** Prefer a composited split-layer preview; fall back to a single-member thumbnail. */
export const useResolvedGroupThumbnail = ({
  fallbackUrl,
  groupId,
}: UseResolvedGroupThumbnailOptions): string | null => {
  const compositeUrl = useGroupCompositeThumbnail(groupId);

  return compositeUrl ?? fallbackUrl ?? null;
};
